export default __webpack_public_path__ + "static/media/Cotidiano_favelado_3.3160a650.jpg";